import { useEffect, useState } from 'react'
import { Tooltip, Icon, Badge } from 'mk-pc'
import { getUnReadMessageCount } from '@/features/message'

export const MessageTip = () => {
  const [count, setCount] = useState(0)
  useEffect(() => {
    fetchCount()

    const timer = setInterval(() => {
      fetchCount()
    }, 60000)

    return () => {
      if (timer) {
        window.clearInterval(timer)
      }
    }
  }, [])

  const fetchCount = () => {
    getUnReadMessageCount().then((res: any) => {
      setCount(res.count)
    })
  }

  return (
    <Tooltip placement="top" title={'消息通知'} arrow={true}>
      <Badge dot={count > 0}>
        <Icon name="icon-tongzhi" />
      </Badge>
    </Tooltip>
  )
}
